export class FoodAlcoholFilterSettingsModel {
  public foodAlcoholName: string;
  public alphaIndex: string;
}